import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../configure_store'
import { INavigationTileItem } from '../../models/navigation_tile_item'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import he from 'he'

const _getState = (state: RootState) => state.tips

export const getTipCategories = (platform = 'web') => createSelector(
  _getState,
  (state) => (
    state.tips.map((tip) => {
      const navigationTile: INavigationTileItem = {
        title: tip.subject,
        icon: tip.icon as IconProp,
        href: (platform === 'web') ? `/meer/preventietips/${tip.id}` : `/dashboard/more/prevention-tips/${tip.id}`
      }

      return navigationTile
    })
  )
)

export const getTipById = (id: number) => createSelector(
  _getState,
  (state) => (
    state.tips.find((tip) => tip.id === id ? tip : undefined)
  )
)
